export default __webpack_public_path__ + "static/media/image-world-class-talent.7588c45e.jpg";